import jwtDecode from "jwt-decode";

export function DecodeToken(token) {
  if (token == null) {
    return null;
  }
  try {
    // Sửa lỗi cách sử dụng thư viện jwt-decode
    let tokenPayload = jwtDecode(token);
    if (tokenPayload) {
      return tokenPayload;
    }
  } catch (error) {
    console.log("Lỗi giải mã token:", error.message || error);
    return null;
  }
}
